import { Reveal } from "./Reveal";
import { CalendarCheck, Wheat, Scissors, PackageCheck } from "lucide-react";

const steps = [
  {
    icon: CalendarCheck,
    n: "1",
    title: "Reserve your share",
    body: "Choose quarter, half, or whole and place your deposit. We set aside one of our animals and book your harvest date.",
  },
  {
    icon: Wheat,
    n: "2",
    title: "Raised by the farmer",
    body: "Your animal is grass fed on pasture, then finished naturally on grain for its final 45 days — all on the same farm. You get updates along the way.",
  },
  {
    icon: Scissors,
    n: "3",
    title: "On a half or whole",
    body: "Every order is discussed on a personal call — we go over the cut sheet together, cut by cut. Thick-cut ribeyes? More grind? Your call. Quarters receive the butcher's standard cut, a balanced mix of everything.",
  },
  {
    icon: PackageCheck,
    n: "4",
    title: "Fill your freezer",
    body: "Once your animal is harvested, your beef is cut, vacuum-sealed, labeled, and frozen by the butcher. Pay the balance on hanging weight and it's yours.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-24 lg:py-32 bg-white border-y border-linen" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="text-xs tracking-[0.25em] uppercase font-bold text-clay mb-4">How It Works</p>
            <h2 className="font-display text-3xl sm:text-4xl tracking-tight font-medium leading-tight">
              From our pasture to your plate, in four steps.
            </h2>
            <p className="text-moss text-base leading-relaxed mt-6">
              No grocery store mystery. You know the farmer, the animal, and the butcher —
              and you pay one honest price per pound of hanging weight.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1} className={i % 2 === 1 ? "sm:mt-10" : ""}>
              <div
                className="group bg-cream rounded-xl border border-linen p-8 h-full hover:shadow-md hover:-translate-y-1 transition-[transform,box-shadow] duration-200"
                data-testid={`how-step-${s.n}`}
              >
                <s.icon className="w-7 h-7 text-clay" strokeWidth={1.5} />
                <div className="flex items-baseline gap-3 mt-6">
                  <span className="font-display italic text-2xl text-clay/70">{s.n}.</span>
                  <h3 className="font-display text-xl sm:text-2xl tracking-tight font-medium">{s.title}</h3>
                </div>
                <p className="text-moss text-base leading-relaxed mt-3">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
